// Fentanyl changing schedules are applied every other day. Count complete
// application dates within each changing section rather than dividing the
// total calendar-day dose by two. An odd-length section includes its first
// and last application dates: 21 days therefore has 11 applications.
export const calculateFentanylChangingPatches = (rows) => {
    return rows?.reduce((acc, { days, dose_rows }) => {
        const sectionDays = parseInt(days, 10) || 0;
        const patchesPerApplication = (dose_rows || [])
            .reduce((sum, dr) => sum + (parseFloat(dr.dose) || 0), 0);

        return acc + (Math.ceil(sectionDays / 2) * patchesPerApplication);
    }, 0) || 0;
};
